<script>import "../libs/texzilla-min.js";
export let size = "1em";
export let align = "left";
export let value;
$: html = TeXZilla.toMathMLString(value);</script>

<div style="font-size:{size};text-align:{align};margin:0 0 0.6em 0">{@html html}</div>
